<template>
  <div class="no_nav_height">
    <messages :modal_message="loading" />
    <div class="row f-row mb-2">
      <div
        class="markets-chart-title col col-12"
        style="text-align: center!important;"
      >
        Derivatives valuation
      </div>
    </div>

    <div class="row f-row mt-1" style="padding: 0 20px 0 20px!important;">
      <div class="col col-12">
        <div class="row f-row" style="position: relative">
          <div
            class="justify-content-center vert-align loading-div"
            v-if="
              Analytics['loading']['accounting'] ||
                Analytics['loading']['valuationFinalSpot'] ||
                Analytics['loading']['valuationInitialSpot'] ||
                !companyParametersReady
            "
          >
            <div class="col col-5 text-center inh">
              Please wait
              <v-progress-circular
                indeterminate
                :size="14"
                :width="1.5"
                color="var(--textaxtive)"
              ></v-progress-circular>
            </div>
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 5px!important;"
              >Company:</span
            >
          </div>
          <div
            class="col col-1 no-dropdown"
            v-if="Analytics['companies'].length === 0"
          >
            N.A.
          </div>
          <div
            class="col col-1 no-dropdown"
            v-else-if="Analytics['companies'].length === 1"
          >
            {{ newSelectedCompanies[0].company_name }}
          </div>
          <div class="col col-1 text-left" v-else>
            <MultiSelect
              v-model="newSelectedCompanies"
              :options="Analytics['companies']"
              :filter="true"
              placeholder="Select Companies"
              class="p-column-filter"
              optionLabel="company_name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">{{
                    slotProps.option.company_name
                  }}</span>
                </div>
              </template>
            </MultiSelect>
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >Portfolios:</span
            >
          </div>
          <div class="col col-1 no-dropdown" v-if="newPortfolios.length === 0">
            N.A.
          </div>
          <div
            class="col col-1 no-dropdown bdr-b-h"
            v-else-if="newPortfolios.length === 1"
          >
            {{ newSelectedPortfolios[0].name }}
          </div>
          <div class="col col-1 text-left" v-else>
            <MultiSelect
              v-model="newSelectedPortfolios"
              :options="newPortfolios"
              :filter="true"
              placeholder="Select Portfolios"
              class="p-column-filter"
              optionLabel="name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">{{ slotProps.option.name }}</span>
                </div>
              </template>
            </MultiSelect>
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >Futures:</span
            >
          </div>
          <div
            class="col col-1 no-dropdown bdr-b-h"
            v-if="newAssets.length === 0"
          >
            N.A.
          </div>
          <div class="col col-1 no-dropdown" v-else-if="newAssets.length === 1">
            {{ newAssets[0].commodity_name }}
          </div>
          <div class="col col-1 text-left" v-else>
            <MultiSelect
              v-model="newSelectedAsset"
              :options="newAssets"
              :filter="true"
              placeholder="Select Futures"
              class="p-column-filter"
              optionLabel="commodity_name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">{{
                    slotProps.option.commodity_name
                  }}</span>
                </div>
              </template>
            </MultiSelect>
          </div>

          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >Start date:</span
            >
          </div>
          <div
            class="col col-1 txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <Calendar
              v-model="newInitialDate"
              dateFormat="M dd, yy"
              placeholder="mmm dd, yyyy"
            />
          </div>

          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >End date:</span
            >
          </div>
          <div
            class="col col-1 txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <Calendar
              v-model="newFinalDate"
              dateFormat="M dd, yy"
              placeholder="mmm dd, yyyy"
            />
          </div>
          <div
            class="col col-1 txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span style="padding: 0 8px 0 16px!important;">Download:</span>
            <button
              @click="download"
              type="submit"
              class="btn-up-dn-load txt-label-primary"
              :class="{ 'btn-disabled': !isTotalOperations }"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col col-1" v-if="!Analytics['valuation']['valuated']">
            <button
              type="button"
              :disabled="showLoadingAll"
              class="btn btn-strat-blue"
              style="margin: 0!important;"
              v-on:click="onUserAccountingValuate"
            >
              <span
                v-if="Analytics['loading']['accounting']"
                class="text-left mr-2"
              >
                <v-progress-circular
                  indeterminate
                  :size="16"
                  :width="2.5"
                  color="var(--textactive-2)"
                ></v-progress-circular
              ></span>
              <span v-if="showLoadingAll">Fetching Data</span>
              <span v-else>Fetch Data</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row f-row mt-2 valuation-height justify-content-center"
      style="padding: 0 20px 0 20px!important; overflow-y: auto;"
    >
      <div class="col col-12" v-if="Analytics['loading']['accounting']">
        <SkeletonValuation />
      </div>
      <div class="col col-12" v-else>
        <div
          class="row f-row mb-1"
          v-for="(total, idxY) in Analytics['valuation']['data']"
          :key="idxY"
        >
          <!-- Table basic -->
          <div class="col col-12">
            <table class="table table-sm table-borderless valuation_table">
              <thead>
                <tr>
                  <th colspan="7">
                    {{ total.name }}
                    <button
                      v-if="total.details.length > 0"
                      class="btn detailView"
                      v-on:click="total.show = !total.show"
                    >
                      <i
                        class="fa fa-minus-circle"
                        style="color:var(--hedge-h); font-size: 1.2rem;"
                        v-if="total.show"
                      ></i>
                      <i
                        class="fa fa-plus-circle"
                        style="color:var(--symmetry-h); font-size: 1.2rem;"
                        v-else
                      ></i>
                    </button>
                  </th>
                </tr>
                <tr>
                  <td>
                    {{ total.totals[0].txt_derivatives }}
                  </td>
                  <td>
                    {{ total.totals[0].txt_strats }}
                  </td>
                  <td>
                    {{ total.totals[0].txt_quantity }}
                  </td>
                  <td>
                    {{ total.totals[0].txt_delta }}
                  </td>
                  <td>
                    {{ total.totals[0].txt_value }}
                  </td>
                  <td>
                    <span v-if="total.totals[0].txt_value_initial != null">
                      {{ total.totals[0].txt_value_initial }}
                    </span>
                  </td>
                  <td>
                    <span v-if="total.totals[0].txt_value_initial != null">
                      Change
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ total.totals[0].n_derivatives }}
                  </td>
                  <td>
                    {{ total.totals[0].n_strats }}
                  </td>
                  <td>
                    <div class="d-flex inh">
                      <span class="mr-auto clr-inctv">
                        {{ total.totals[0].quantity_unit }}
                      </span>
                      <span class="inh">
                        {{ total.totals[0].quantity | valuationFormat }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex inh">
                      <span class="mr-auto clr-inctv">
                        {{ total.totals[0].quantity_unit }}
                      </span>
                      <span class="inh">
                        {{ total.totals[0].delta | valuationFormat }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex inh">
                      <span class="mr-auto clr-inctv">
                        {{ total.totals[0].curr_value }}
                      </span>
                      <span
                        class="value-pill inh"
                        style="margin: 0 5px 0 5px; padding-right: 5px; font-size: 1.05rem; font-weight: bold;"
                      >
                        {{ total.totals[0].hedge_value | valuationFormat }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div
                      class="d-flex inh"
                      v-if="total.totals[0].txt_value_initial != null"
                    >
                      <span class="mr-auto clr-inctv">
                        {{ total.totals[0].curr_value }}
                      </span>
                      <span class="inh">
                        {{
                          total.totals[0].hedge_value_initial | valuationFormat
                        }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div
                      class="d-flex inh"
                      v-if="total.totals[0].txt_value_initial != null"
                    >
                      <span class="mr-auto clr-inctv">
                        {{ total.totals[0].curr_value }}
                      </span>
                      <span
                        class="value-pill inh"
                        style="margin: 0 5px 0 5px; padding-right: 5px; font-size: 1.05rem; font-weight: bold;"
                      >
                        {{
                          (total.totals[0].hedge_value -
                            total.totals[0].hedge_value_initial)
                            | valuationFormat
                        }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Table show more -->
          <div class="col col-12">
            <DataTable
              v-if="total.show"
              :alwaysShowPaginator="true"
              :paginator="true"
              :value="total.details"
              :filters.sync="dFilters"
              :loading="showLoadingAll"
              :rowHover="true"
              :rows="15"
              :rowsPerPageOptions="[10, 15, 20, 25, 30, 50, 100, 1000]"
              :scrollable="true"
              :selection.sync="total.selected"
              :virtual="true"
              ref="dt"
              class="p-datatable-sm editable-cells-table"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              :filterDisplay="showFilters ? 'menu' : ''"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              responsiveLayout="scroll"
              stickyHeader="true"
            >
              <Column
                field="custom_id"
                header="Code"
                sortable
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  {{ data.custom_id }}
                </template>
                <template #filter="{filterModel}">
                  <InputText
                    type="text"
                    v-model="filterModel.value"
                    class="p-column-filter"
                    placeholder="Search by code"
                  />
                </template>
              </Column>

              <Column
                field="end_product_str"
                header="Product"
                sortable
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  {{ data.end_product_str }}
                </template>
                <template #filter="{filterModel}">
                  <InputText
                    type="text"
                    v-model="filterModel.value"
                    class="p-column-filter"
                    placeholder="Search by code"
                  />
                </template>
              </Column>

              <Column
                header="Futures"
                sortable
                filterField="futures"
                sortField="futures"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '14rem' }"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  {{ data.futures }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Futures Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="Analytics['valuation']['dDowns'].futuresDDown"
                    placeholder="Select Futures"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                v-if="Analytics['valuation']['dDowns'].contractDDown.length > 0"
                header="Contract"
                sortable
                filterField="contract_month_year"
                sortField="contract_month_year"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '5rem' }"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  {{ data.contract_month_year }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Contract Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="Analytics['valuation']['dDowns'].contractDDown"
                    placeholder="Select Contract"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                header="Portfolio"
                sortable
                filterField="portfolio"
                sortField="portfolio"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '14rem' }"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  {{ data.portfolio }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Portfolio Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="Analytics['valuation']['dDowns'].portfoliosDDown"
                    placeholder="Select Portfolios"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                v-if="Analytics['valuation']['dDowns'].counterPDDown.length > 0"
                header="Counter- party"
                sortable
                filterField="counterparty"
                sortField="counterparty"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '14rem' }"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  {{ data.counterparty }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Portfolio Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="Analytics['valuation']['dDowns'].counterPDDown"
                    placeholder="Select Counterparty"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                v-if="
                  Analytics['valuation']['dDowns'].strategiesDDown.length > 0
                "
                header="Strategy"
                sortable
                filterField="strategy_name"
                sortField="strategy_name"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '14rem' }"
                :styles="{ 'min-width': '10rem' }"
              >
                <template #body="{data}">
                  {{ data.strategy_name }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Strategy Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="Analytics['valuation']['dDowns'].strategiesDDown"
                    placeholder="Select Strategy"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                header="Long | Short"
                sortable
                filterField="buy_sell"
                sortField="buy_sell"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '8rem' }"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  {{ data.buy_sell }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Position Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="['LONG', 'SHORT', 'OFFSET LONG', 'OFFSET SHORT']"
                    placeholder="Select Position"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                header="Derivative"
                sortable
                filterField="derivative"
                sortField="derivative"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '8rem' }"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  <img
                    :alt="data.derivative"
                    :src="data.dImg"
                    width="12"
                    style="vertical-align: middle"
                  />
                  <span class="image-text">&nbsp;{{ data.derivative }}</span>
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Derivative Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="['FUTURE', 'FORWARD', 'CALL', 'PUT']"
                    placeholder="Select Derivative"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                field="trade_date"
                header="Trade Date"
                sortable
                dataType="date"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.trade_date | dateFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <Calendar
                    v-model="filterModel.value"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yyyy"
                  />
                </template>
              </Column>

              <Column
                header="Days"
                field="days_to_expiration"
                sortable
                dataType="date"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span
                    v-if="data.date > newFinalDate"
                    class="inh"
                    style="width: 100%; text-align: center"
                  >
                    {{ data.days_to_expiration }}
                  </span>
                  <span
                    v-else
                    class="expired-pill inh"
                    style="width: 100%; text-align: center"
                  >
                    {{ data.days_to_expiration }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                header="Closing Date"
                field="date"
                sortable
                dataType="date"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span
                    v-if="data.date > newFinalDate"
                    class="inh"
                    style="width: 100%; text-align: center"
                  >
                    {{ data.date | dateFormat }}
                  </span>
                  <span
                    v-else
                    class="expired-pill inh"
                    style="width: 100%; text-align: center"
                  >
                    {{ data.date | dateFormat }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <Calendar
                    v-model="filterModel.value"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yyyy"
                  />
                </template>
              </Column>

              <Column
                field="quantity"
                header="Quantity"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.quantity | numberFormat }}
                    {{ data.unit }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                header="Strike"
                field="strike"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.strike | priceFormat }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="fwd"
                header="Price"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.fwd | priceFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="hedge_value"
                header="Valuation"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span
                    class="value-pill inh"
                    style="width: 100%; text-align: center"
                  >
                    {{ data.curr }}
                    {{ (data.hedge_value - data.premium) | numberFormat }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                header="Premium"
                field="premium"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.premium_currency }}
                    {{ data.premium | numberFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="fwd_initial"
                header="Prev. Price"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.fwd_initial | priceFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="hedge_value_initial"
                header="Prev. Valuation"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.curr }}
                    {{
                      (data.hedge_value_initial - data.premium) | numberFormat
                    }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="delta"
                header="Delta"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.delta | percFormat }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="delta_initial"
                header="Prev. Delta"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.delta_initial | percFormat }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="volatility"
                header="Volatility"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.volatility | percFormat }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                field="volatility_initial"
                header="Prev. Volatility"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '6rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.volatility_initial | percFormat }}
                  </span>
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                header="Derivative Type"
                sortable
                filterField="derivative_type"
                sortField="derivative_type"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '8rem' }"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  {{ data.derivative_type }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Type Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="optionTypes"
                    optionLabel="name"
                    optionValue="name"
                    placeholder="Select Type"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{
                          slotProps.option.name
                        }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                header="Settlement Type"
                sortable
                filterField="settlement_type"
                sortField="settlement_type"
                :showFilterMatchModes="false"
                :filterMenuStyle="{ width: '8rem' }"
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  {{ data.settlement_type }}
                </template>
                <template #filter="{filterModel}">
                  <div class="mb-3 font-bold">Type Picker</div>
                  <MultiSelect
                    v-model="filterModel.value"
                    :options="['DELIVERABLE', 'NON DELIVERABLE']"
                    placeholder="Select Type"
                    class="p-column-filter"
                    scrollHeight="400px"
                  >
                    <template #option="slotProps">
                      <div class="p-multiselect-representative-option">
                        <span class="image-text">{{ slotProps.option }}</span>
                      </div>
                    </template>
                  </MultiSelect>
                </template>
              </Column>

              <Column
                v-if="showAllFields"
                header="Barrier"
                field="barrier"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.barrier | numberFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                v-if="showAllFields"
                header="Second Barrier"
                field="barrier_2"
                sortable
                dataType="numeric"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.barrier_2 | numberFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <InputNumber v-model="filterModel.value" />
                </template>
              </Column>

              <Column
                v-if="showAllFields"
                header="Asian Start"
                field="asian_fixing_start_date"
                sortable
                dataType="date"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.asian_fixing_start_date | dateFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <Calendar
                    v-model="filterModel.value"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yyyy"
                  />
                </template>
              </Column>

              <Column
                v-if="showAllFields"
                header="Strategy Code"
                field="strategy_code"
                sortable
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.strategy_code }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <InputText
                    type="text"
                    v-model="filterModel.value"
                    class="p-column-filter"
                    placeholder="Search by code"
                  />
                </template>
              </Column>
              <Column
                v-if="showAllFields"
                field="custom_name"
                header="Custom Name"
                sortable
                :styles="{ 'min-width': '8rem' }"
              >
                <template #body="{data}">
                  {{ data.custom_strategy_name }}
                </template>
                <template #filter="{filterModel}">
                  <InputText
                    type="text"
                    v-model="filterModel.value"
                    class="p-column-filter"
                    placeholder="Search by code"
                  />
                </template>
              </Column>

              <Column
                header="Premium Date"
                field="premium_value_date"
                sortable
                dataType="date"
                :styles="{ 'min-width': '5rem' }"
              >
                <template #body="{data}">
                  <span style="width: 100%; text-align: center">
                    {{ data.premium_value_date | dateFormat }}</span
                  >
                </template>
                <template #filter="{filterModel}">
                  <Calendar
                    v-model="filterModel.value"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yyyy"
                  />
                </template>
              </Column>

              <Column
                v-if="showAllFields"
                field="comments"
                header="Comments"
                sortable
                :styles="{ 'min-width': '10rem' }"
              >
                <template #body="{data}">
                  {{ data.comments }}
                </template>
                <template #filter="{filterModel}">
                  <InputText
                    type="text"
                    v-model="filterModel.value"
                    class="p-column-filter"
                    placeholder="Search by code"
                  />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Calendar from "primevue/calendar";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import SkeletonValuation from "@/components/analytics/SkeletonValuation";
import { format, timeFormat } from "d3";
import { formatPercent } from "@/_core/_helpers/_parametric_tools";
import { createExcelValuation } from "../../_core/data/createExcel";
import Messages from "../modals/Messages.vue";

export default {
  name: "MonthlyValuationCmdty",
  components: {
    Calendar,
    Column,
    DataTable,
    InputNumber,
    InputText,
    MultiSelect,
    SkeletonValuation,
    Messages
  },
  props: {
    Analytics: {
      required: true
    },
    companyParametersReady: { required: true, type: Boolean, default: false },
    dataFilters: { required: true },
    processData: { required: true }
  },
  data() {
    return {
      dFilters: this.Analytics.valuation.dataFilters,
      showAllFields: true,
      showFilters: true,
      loading: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false
      }
    };
  },
  computed: {
    newFinalDate: {
      get: function() {
        return this.Analytics["valuation"]["finalDate"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserFinalDate", newValue);
        this.setValuationData();
      }
    },
    newInitialDate: {
      get: function() {
        return this.Analytics["valuation"]["initialDate"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserInitialDate", newValue);
        this.setValuationData();
      }
    },
    newSelectedCompanies: {
      get: function() {
        return this.Analytics["userSelections"]["selectedCompanies"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserCompany", newValue);
        this.setValuationData();
      }
    },
    newPortfolios() {
      return this.Analytics["userSelections"]["portfolios"];
    },
    newSelectedPortfolios: {
      get: function() {
        return this.Analytics["userSelections"]["selectedPortfolios"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserPortfolio", newValue);
        this.setValuationData();
      }
    },
    newAssets() {
      return this.Analytics["userSelections"]["underlying"];
    },
    newSelectedAsset: {
      get: function() {
        return this.Analytics["userSelections"]["selectedUnderlying"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserUnderlying", newValue);
        this.setValuationData();
      }
    },
    showLoadingAll() {
      return (
        this.Analytics["loading"]["accounting"] ||
        this.Analytics["loading"]["valuationFinalSpot"] ||
        this.Analytics["loading"]["valuationInitialSpot"]
      );
    },
    isTotalOperations() {
      return this.Analytics["valuation"]["data"].some(
        d =>
          d.name === "Open positions" &&
          Array.isArray(d.details) &&
          d.details.length > 1
      );
    }
  },
  watch: {
    dataFilters(fltr) {
      Object.assign(this, {
        dFilters: fltr
      });
    },
    dFilters(fltr) {
      this.$emit("eventOnUserFilter", fltr);
    }
  },
  methods: {
    // fillImg(data) {
    //   let _this = this;
    //   data.forEach(function(d) {
    //     d.dImg = derivativeImage(
    //       {
    //         derivative: d.derivative.toLowerCase(),
    //         buy_sell: d.buy_sell.toLowerCase()
    //       },
    //       _this.lFwd,
    //       _this.sFwd,
    //       _this.lCall,
    //       _this.sCall,
    //       _this.lPut,
    //       _this.sPut
    //     );
    //   });
    //   return data;
    // },
    // // ==== table
    // onRowExpand(event) {
    //   this.$toast.add({
    //     severity: "info",
    //     summary: "Row Expanded",
    //     detail: "Vin: " + event.data.index,
    //     life: 3000
    //   });
    // },
    // onRowCollapse(event) {
    //   this.$toast.add({
    //     severity: "success",
    //     summary: "Row Collapsed",
    //     detail: "Vin: " + event.data.index,
    //     life: 3000
    //   });
    // },
    // expandAll() {
    //   this.expandedRows = this.initialHedgesValuation.filter(d => d.index);
    //   this.$toast.add({
    //     severity: "success",
    //     summary: "All Rows Expanded",
    //     life: 3000
    //   });
    // },
    // collapseAll() {
    //   this.expandedRows = null;
    //   this.$toast.add({
    //     severity: "success",
    //     summary: "All Rows Collapsed",
    //     life: 3000
    //   });
    // },
    download() {
      const nameCompany = this.newSelectedCompanies[0].company_name;
      const data = this.Analytics["valuation"]["data"].filter(
        d => d.name === "Open positions"
      );
      if (this.isTotalOperations) {
        createExcelValuation(
          this,
          "valuation",
          nameCompany,
          data,
          "comm_valuation"
        );
      }
    },
    // ==== other
    onUserAccountingValuate() {
      this.$emit("eventOnUserAccountingValuate");
    },
    setValuationData() {
      Object.assign(this.Analytics.valuation, {
        data: this.Analytics.analyticsManager.defineEmptyValTable()
      });
    }
  },
  filters: {
    valuationFormat: function(val) {
      if (!val) {
        return "-";
      } else {
        return val === 0 ? "-" : format(",.0f")(val);
      }
    },
    numberFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",")(Math.round(val));
    },
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
    percFormat: function(val) {
      return val === null || val === 0 ? "-" : formatPercent(val);
    },
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    }
  }
};
</script>

<style scoped>
.btn-disabled:focus,
.btn-disabled:active,
.btn-disabled:focus:hover,
.btn-disabled:hover {
  color: var(--textinactive);
  box-shadow: none !important;
  -moz-box-shadow: none;
}
</style>
